<div class="flex flex-col gap-6 p-6">
	<div class="flex flex-col gap-4">
		<div class="flex items-center gap-2">
			<h3 class="h3">Pronoun Settings by Firm or Office</h3>
			<i-tabler
				name="info-circle"
				class="w-5 h-5 text-gray-500 cursor-help"
				[matTooltip]="vm.tooltipText"
				matTooltipPosition="below"
			></i-tabler>
		</div>

		<ui-button-segmented
			[options]="[
				{ id: 'firm', label: 'By Firm' },
				{ id: 'office', label: 'By Office' },
			]"
			[(selectedId)]="vm.selectedSettingType"
			[fullWidth]="true"
			variant="text-only"
		></ui-button-segmented>

		<!-- Firm View -->
		<div *ngIf="vm.selectedSettingType === 'firm'" class="flex flex-col gap-2">
			<app-dropdown
				[placeholder]="'Select Pronoun Type'"
				[itemGroups]="[
					{
						items: [
							{ value: 'Singular', name: 'Singular' },
							{ value: 'Plural', name: 'Plural' },
						],
					},
				]"
				[value]="vm.firmPronounValue()"
				(onSelect)="vm.onSelectFirmPronoun($event.result.value)"
			></app-dropdown>
		</div>

		<!-- Office View -->
		<div
			*ngIf="vm.selectedSettingType === 'office'"
			class="flex flex-col gap-4 w-full"
		>
			<div
				*ngFor="let office of vm.offices()"
				class="flex flex-col gap-2 w-full"
			>
				<p>{{ office.officeName }}*</p>
				<app-dropdown
					[placeholder]="'Select Pronoun Type'"
					[itemGroups]="[
						{
							items: [
								{ value: 'Singular', name: 'Singular' },
								{ value: 'Plural', name: 'Plural' },
							],
						},
					]"
					[value]="vm.officePronounValues()[office.id]"
					(onSelect)="vm.onSelectOfficePronoun(office, $event.result.value)"
				></app-dropdown>
			</div>
		</div>
	</div>

	<div class="flex flex-col gap-4">
		<h3 class="h3">Add Custom Pronoun Settings (by Lawyer)</h3>

		<div class="flex flex-col gap-4">
			<div class="flex-1">
				<app-dropdown
					[placeholder]="'Select lawyer'"
					[itemGroups]="vm.lawyerDropdownItems()"
					(onSelect)="vm.onSelectLawyer($event.result)"
					[ngModel]="vm.selectedLawyerName()"
				></app-dropdown>
			</div>
			<div class="flex-1">
				<app-dropdown
					[placeholder]="'Select Pronoun Type'"
					[itemGroups]="[
						{
							items: [
								{ value: 'Singular', name: 'Singular' },
								{ value: 'Plural', name: 'Plural' },
							],
						},
					]"
					[value]="vm.selectedLawyerPronoun()"
					(onSelect)="vm.onSelectLawyerPronoun($event.result.value)"
				></app-dropdown>
			</div>

			<ui-button
				[icon]="'plus'"
				[label]="'Add Custom Setting'"
				[color]="'secondary'"
				[preset]="'DEFAULT'"
				(click)="vm.onAddOverride()"
			></ui-button>
		</div>

		<div class="flex flex-col gap-4 mt-4">
			<div class="overflow-hidden border border-gray-200 rounded-xl">
				<table class="w-full">
					<thead>
						<tr class="border-b border-gray-200 bg-grey-lightest">
							<th class="p-3 text-left font-medium">Lawyer</th>
							<th class="p-3 text-left font-medium border-l border-gray-200">
								Pronoun
							</th>
							<th class="p-3 w-12"></th>
						</tr>
					</thead>
					<tbody>
						<ng-container
							*ngIf="vm.lawyerOverrides().length > 0; else noOverrides"
						>
							<tr
								*ngFor="let override of vm.lawyerOverrides(); let isLast = last"
								[ngClass]="{ 'border-b border-gray-200': !isLast }"
							>
								<td class="p-3">
									{{ override.lawyer.firstName }} {{ override.lawyer.lastName }}
								</td>
								<td class="p-3 border-l border-gray-200">
									{{ override.pronoun }}
								</td>
								<td class="p-3 text-right">
									<ui-button
										[icon]="'trash'"
										[preset]="'ICON_DEFAULT'"
										[size]="'sm'"
										(click)="vm.onDeleteLawyerOverride(override.lawyer.id!)"
									></ui-button>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>
			</div>
			<ng-template #noOverrides>
				<div class="py-4 text-center text-gray-500">No custom settings</div>
			</ng-template>
		</div>
	</div>
</div>
